import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { ROUTE_FINISH_REGISTRATION, ROUTE_PERSONAL_INFORMATION_PROCESSING, ROUTE_MOBILE_SIGNATURE } from '../../constants';
import FinishRegistration from '../../pages/finish-registration';
import PersonalInformationProcessing from '../../pages/personal-information-processing';
import MobileSignaturePage from '../../pages/mobile-signature';
import Login from '../login';

const UnauthorizedLayout = () => {
  return (
    <Switch>
      <Route exact path={ROUTE_MOBILE_SIGNATURE} component={MobileSignaturePage} />
      <Route exact path={ROUTE_FINISH_REGISTRATION} component={FinishRegistration} />
      <Route
        exact
        path={ROUTE_PERSONAL_INFORMATION_PROCESSING}
        component={PersonalInformationProcessing}
      />
      <Route exact path={'*'} component={Login} />
    </Switch>
  );
};

export default withRouter(UnauthorizedLayout);
